/** Changing AI recipients requires a new affirmative permission. */
export const STUDIO_AI_DATA_CONSENT_VERSION = '2026-10-17.2-haiku'
